import type { Resolver } from 'react-hook-form'

import type { Answers } from '@/modules/contato/components/ContactFormStep/index'

import {
  type ContactFieldName,
  type ContactFieldValue,
  createDynamicContactResolver,
} from '@/modules/contato/pages/dinamicSchema/index'

export const contactPidQuestionNames = [
  'cpf',
  'fullName',
  'email',
  'emailConfirmation',
  'phone',
  'role',
  'companyName',
  'cnpj',
] as const satisfies readonly ContactFieldName[]

type ContactPidFieldName = (typeof contactPidQuestionNames)[number]

type OptionalContactPidFields = Extract<ContactPidFieldName, 'cnpj'>

export type ContactPidFormData = {
  [FieldName in Exclude<
    ContactPidFieldName,
    OptionalContactPidFields
  >]: ContactFieldValue<FieldName>
} & {
  [FieldName in OptionalContactPidFields]?: ContactFieldValue<FieldName>
}

export function createContactPidResolver(
  fallbackAnswers?: Answers,
): Resolver<ContactPidFormData> {
  return createDynamicContactResolver<ContactPidFormData>({
    questionNames: contactPidQuestionNames,
    fallbackAnswers,
  })
}
